import { initializeApp, type FirebaseApp } from 'firebase/app'
import { connectAuthEmulator, getAuth, type Auth } from 'firebase/auth'
import {
  connectFirestoreEmulator,
  initializeFirestore,
  persistentLocalCache,
  persistentMultipleTabManager,
  type Firestore,
} from 'firebase/firestore'
import { firebaseConfig, isFirebaseConfigured, useEmulators } from './env'

interface Services {
  app: FirebaseApp
  auth: Auth
  db: Firestore
}

let services: Services | null = null

/**
 * Firestore's own persistence is the offline story — no parallel local cache is
 * built on top of it. Multi-tab manager so a desktop tab and the PWA can both be
 * open without fighting over the lease.
 */
export function firebase(): Services {
  if (services) return services
  if (!isFirebaseConfigured) {
    throw new Error('Firebase is not configured; check missingFirebaseEnv before calling firebase().')
  }

  const app = initializeApp(firebaseConfig)
  const auth = getAuth(app)
  auth.useDeviceLanguage()
  const db = initializeFirestore(app, {
    localCache: persistentLocalCache({ tabManager: persistentMultipleTabManager() }),
  })

  if (useEmulators) {
    connectAuthEmulator(auth, 'http://127.0.0.1:9099', { disableWarnings: true })
    connectFirestoreEmulator(db, '127.0.0.1', 8080)
  }

  services = { app, auth, db }
  return services
}
